import React from "react";
import { useMediaQuery, useTheme } from "@material-ui/core";
import { ArticleSkeleton } from "common/ui/skeleton-ui";
import SectionTab from "constants/SectionTab";
import ListItemGrid from "modules3/components/ListItemGrid";
import { ShowMore } from "modules2/components";
import { makeStyles } from "@material-ui/core/styles";
import container from "./GenresPodCastCard.container";

const useStyles = makeStyles((theme) => ({
  articleContainer: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    marginTop: 10,
  },
  empty: {
    fontFamily: theme.typography.fontFamily,
    paddingBottom: theme.spacing(1),
  },
  emptytext: {
    textAlign: "center",
    width: "100%",
    position: "relative",
    paddingBottom: theme.spacing(1),
    fontFamily: theme.typography.fontFamily,
    textTransform: "capitalize",
  },
}));

const GenresPodCastCard = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const matchesXS = useMediaQuery(theme.breakpoints.down("xs"));
  const {
    podcastState: {
      podcastLoading,
      currentGenres,
      genres,
      genresPodcasts,
      podcastCurrentPage,
    },
    userHistoryPodcastState: { heartedPodcastIds },
    onSetCurrentTab,
    onViewPodCastStart,
    onFetchPodCastEpisode,
    onFetchApplePodcastEpisode,
    onFetchListenNotesPodcastEpisode,
    onFavouritePodcast,
    onRemovePodcastHeartStart,
    onRequestGenresPodcast,
    onShowSnackbarNotification,
    onSetCurrentViewdPodPlaylist,
  } = props;

  const onListItemClick = (tab, uuid) => {
    onSetCurrentTab(tab);
    onViewPodCastStart(uuid);
    onFetchPodCastEpisode(uuid);
    onSetCurrentViewdPodPlaylist(uuid);
    /*const id = uuid.toString();
        if (id.length < 15 && id.startsWith('p')) {
            onFetchPodCastEpisode(uuid);
        } else if (id.length <= 15) {
            onFetchApplePodcastEpisode(uuid);
        } else {
            onFetchListenNotesPodcastEpisode(uuid);
        }*/
  };

  const genreName = genres
    .filter((e) => e.id === currentGenres)
    .map((genres) => genres.name);

  const onFavouriteClick = (id) => {
    const index = heartedPodcastIds.indexOf(id);
    if (index === -1) {
      onShowSnackbarNotification(`Podcast Hearted ❤️`);
      onFavouritePodcast(id);
    } else {
      onShowSnackbarNotification(`Podcast Un-hearted 😢`);
      onRemovePodcastHeartStart(id);
    }
  };

  const nextItem = () => {
    onRequestGenresPodcast(currentGenres, podcastCurrentPage);
  };

  const displayList = (loading) => {
    if (loading) {
      return [...Array(matchesXS ? 4 : 9)].map((_, idx) => {
        return <ArticleSkeleton key={idx} />;
      });
    }
    return Object.keys(genresPodcasts).map((value) => {
      if (
        genresPodcasts[value].filter &&
        genresPodcasts[value].filter.includes(currentGenres)
      ) {
        return (
          <ListItemGrid
            key={value}
            sectionTab={SectionTab.PodCastDetail}
            podcastid={genresPodcasts[value].id}
            image={genresPodcasts[value].image}
            title={genresPodcasts[value].text}
            subtitle={genresPodcasts[value].subtext}
            data={genresPodcasts[value]}
            onListItemClick={onListItemClick}
            onFavouriteClick={onFavouriteClick}
          />
        );
      } else if (
        genresPodcasts[value].genre_ids &&
        genresPodcasts[value].genre_ids.includes(currentGenres)
      ) {
        return (
          <ListItemGrid
            key={value}
            sectionTab={SectionTab.PodCastDetail}
            podcastid={genresPodcasts[value].id}
            image={genresPodcasts[value].image}
            title={genresPodcasts[value].title}
            subtitle={genresPodcasts[value].country}
            data={genresPodcasts[value]}
            onListItemClick={onListItemClick}
            onFavouriteClick={onFavouriteClick}
          />
        );
      } else if (
        genresPodcasts[value].genreIds &&
        genresPodcasts[value].genreIds.includes(currentGenres)
      ) {
        return (
          <ListItemGrid
            key={value}
            sectionTab={SectionTab.PodCastDetail}
            podcastid={genresPodcasts[value].trackId}
            image={
              genresPodcasts[value].artworkUrl600 ??
              genresPodcasts[value].artworkUrl100
            }
            title={genresPodcasts[value].trackName}
            subtitle={genresPodcasts[value].trackCensoredName}
            data={genresPodcasts[value]}
            onListItemClick={onListItemClick}
            onFavouriteClick={onFavouriteClick}
          />
        );
      } else if (
        genresPodcasts[value].categories &&
        Object.keys(genresPodcasts).some(
          (key) => genresPodcasts[key] === currentGenres
        )
      ) {
        return (
          <ListItemGrid
            key={value}
            sectionTab={SectionTab.PodCastDetail}
            podcastid={genresPodcasts[value].id}
            image={genresPodcasts[value].image ?? "null"}
            title={genresPodcasts[value].title}
            subtitle={
              genresPodcasts[value].country ??
              genresPodcasts[value].releaseDate ??
              genresPodcasts[value].language
            }
            data={genresPodcasts[value]}
            onListItemClick={onListItemClick}
            onFavouriteClick={onFavouriteClick}
          />
        );
      } else {
        return null;
      }
    });
  };

  return (
    <>
      <div className={classes.articleContainer}>
        {displayList(podcastLoading)}
      </div>
      {!podcastLoading && Object.keys(genresPodcasts).length > 0 ? (
        <ShowMore nextRadioList={nextItem} />
      ) : (
        !podcastLoading && (
          <div className={classes.emptytext}>
            {genreName} Podcast not found.
          </div>
        )
      )}
    </>
  );
};

export default container(GenresPodCastCard);
